import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const setSigninStep = (step: string): FluxStandardAction => {
    return {
        type: Actions.SET_SIGNIN_STEP,
        payload: {
            data: step
        }
    }
};

export const fetchGetCurrentUser = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CURRENT_USER,
    }
};

export const fetchGetPartnerStatus = (PartnerStatus: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_PARTNER_DETAILS,
        payload: {
            data: PartnerStatus
        }
    }
};

export const fetchGetCurrentUserSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CURRENT_USER_SUCCESS,
        payload: {
            data: data
        }
    }
};

export const fetchGetCurrentUserError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CURRENT_USER_ERROR,
        payload: {
            data: error
        }
    }
};

export const fetchGetCheckMobileNumber = (mobile: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_MOBILE_NUMBER,
        payload: {
            mobile: mobile
        }
    }
};

export const fetchGetCheckMobileNumberSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_MOBILE_NUMBER_SUCCESS,
        payload: {
            data: data
        }
    }
};

export const fetchGetCheckMobileNumberError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_CHECK_MOBILE_NUMBER_ERROR,
        payload: {
            data: error
        }
    }
};

export const fetchVerifyPassword = (username: string, password: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_VERIFY_PASSWORD,
        payload: {
            username: username,
            password: password
        }
    }
};

export const fetchVerifyPasswordSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_VERIFY_PASSWORD_SUCCESS,
        payload: {
            data: data
        }
    }
};

export const fetchVerifyPasswordError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_VERIFY_PASSWORD_ERROR,
        payload: {
            data: error
        }
    }
};

export const fetchSendLoginOtp = (mobile: string, action: number): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_LOGIN_OTP,
        payload: {
            mobile: mobile,
            action: action
        }
    }
};

export const fetchSendLoginOtpSuccess = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_LOGIN_OTP_SUCCESS,
    }
};

export const fetchSendLoginOtpError = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_LOGIN_OTP_ERROR,
    }
};

export const fetchVerifyLoginOtp = (otp: string, mobile: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_VERIFY_LOGIN_OTP,
        payload: {
            otp: otp,
            mobile: mobile
        }
    }
};

export const fetchVerifyLoginOtpSuccess = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_VERIFY_LOGIN_OTP_SUCCESS,
    }
};

export const fetchVerifyLoginOtpError = (incorrectOTP: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_POST_VERIFY_LOGIN_OTP_ERROR,
        payload: incorrectOTP
    }
};

export const fetchUpdateUserPassword = (mobile: string, password: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_UPDATE_USER_PASSWORD,
        payload: {
            mobile: mobile,
            password: password
        }
    }
};

export const fetchUpdateUserPasswordSuccess = (userInfo: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_UPDATE_USER_PASSWORD_SUCCESS,
        payload: {
            data: userInfo
        }
    }
};

export const fetchUpdateUserPasswordError = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_UPDATE_USER_PASSWORD_ERROR,
    }
};

export const fetchUserLogin = (emailId: string, mobile: string, userName: string, password: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_USER_LOGIN,
        payload: {
            emailId: emailId,
            mobile: mobile,
            userName: userName,
            password: password
        }
    }
};

export const fetchUserLoginSuccess = (userInfo: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_USER_LOGIN_SUCCESS,
        payload: {
            data: userInfo
        }
    }
};

export const fetchUserLoginError = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_USER_LOGIN_ERROR,
    }
};

export const setEnteredWrongPassword = (enteredWrongPassword: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_ENTERED_WRONG_PASSWORD,
        payload: {
            data: enteredWrongPassword
        }
    }
};

export const setUserMappedToOtherAgent = (userMappedToOtherAgent: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_USER_MAPPED_TO_OTHER_AGENT,
        payload: {
            data: userMappedToOtherAgent
        }
    }
};

export const setOtpVerified = (otpVerified: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_OTP_VERIFIED,
        payload: {
            data: otpVerified
        }
    }
};

export const setIncorrectOtp = (incorrectOtp: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_INCORRECT_OTP,
        payload: {
            data: incorrectOtp
        }
    }
};
export const fetchgetPortfolioDetails = (isAdminFlow:false, ucc: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_PORTFOLIO_DETAILS,
        payload: {
            isAdminFlow: isAdminFlow,
            ucc: ucc
        }
    }
};

export const fetchgetPortfolioDetailsSuccess = (portfolioData: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_PORTFOLIO_DETAILS_SUCCESS,
        payload: {
            data: portfolioData
        }
    }
};
